<template>
 <router-view v-slot="{ Component, route }">
   <component :is="Component" :key="route.fullPath" />
 </router-view>
</template>

<script>

export default {
  name: 'App',
  components: {
  },
  beforeCreate(){
    const user = localStorage.getItem('ENSPSID');
    if (user) {
      const s = this.$store;
      // Critical: auth + universal reference data only
      // Pages load their own specific data lazily (with cache guards)
      s.dispatch('authfack/getProfile').catch(() => {});
      s.dispatch('getProducts').catch(() => {});
      s.dispatch('get_categories').catch(() => {});
      s.dispatch('get_settings').catch(() => {});
      s.dispatch('get_customers').catch(() => {});
      s.dispatch('get_suppliers').catch(() => {});
      s.dispatch('get_wharehouses').catch(() => {});
    }
  }

}
</script>
